/* Cart extras: the add on toggle.
 *
 * Horizon owns the cart and re renders it by morphing, so this script never
 * holds state. It changes the cart, asks Shopify to re render the section the
 * toggle lives in, and swaps the fresh markup back in.
 *
 * ⛔ In the DRAWER the whole section must not be replaced: that would destroy
 * the open <dialog> and the drawer would slam shut mid click. So only the two
 * inner panels are swapped there.
 * ⛔ On the CART PAGE those panels do not exist, and the first version fell
 * through to a full reload every time. There is no dialog to protect there, so
 * the whole section can be replaced.
 *
 * The listener is delegated on document, because the nodes it targets are
 * replaced on every cart change and a bound handler would be thrown away.
 */
(function () {
  // ⛔ טעינה שנייה של הקובץ, בעמוד שיש בו גם מגירה וגם עגלה, חזרה קודם בשקט
  // ולא הציבה את הבלוק השני. עכשיו היא לפחות מריצה את ההצבה.
  if (window.__kaCartExtras) {
    if (window.__kaCxPlace) window.__kaCxPlace();
    return;
  }
  window.__kaCartExtras = true;

  var busy = false;
  // ⛔ The first version swapped .cart-drawer__content and .cart-drawer__summary
  // and the toggle never flipped, because in Horizon both of those live INSIDE
  // cart-items-component while these extras are rendered as its sibling. The
  // swap kept replacing subtrees that did not contain the row. The element that
  // actually holds the items, the summary and the extras is cart-items-component,
  // and it is not the dialog, so replacing it is safe while the drawer is open.
  var PANELS = ['cart-items-component', '.cart-drawer__inner'];

  /* ⛔ Liquid can only render these extras after {{ children }}, which in Horizon
   * puts them BELOW the totals and the checkout button. An upsell under the
   * checkout button is an upsell nobody sees. The summary is nested inside the
   * same component, so no ordering trick in CSS can lift the extras above it,
   * and the block that renders the drawer summary is not the one that renders
   * the cart page summary. Moving the node is the one fix that holds in both.
   *
   * .ka-cx starts hidden in CSS and is only revealed once it has been placed,
   * so it never flashes at the bottom first.
   */
  /* ---------- שם תוכנית המנוי ----------
   * ⛔ שופיפיי מייצר את שם התוכנית באנגלית, "Deliver every month, 20% off",
   * וזה מה שהערכה מדפיסה בשורת המוצר בעגלה. אי אפשר לתקן את זה מהצד שלנו
   * בלי לגעת בקובץ ליבה של Horizon, וגם אז זה לא היה משנה את מה שמופיע
   * בעמוד התשלום, שם רק שינוי השם של התוכנית עצמה בשופיפיי עוזר.
   * ⭐ לכן מוחלפת כאן רק התבנית האוטומטית של שופיפיי. ברגע שתקבל התוכנית
   * שם משלה, בעברית או בכל שפה אחרת, הקוד הזה לא נוגע בו.
   * ⛔ בלי מזהים קשיחים. הכל נגזר מהטקסט עצמו, אז זה עובד בכל חנות
   * שתקבל את הערכה הזאת.
   */
  var PLAN_EN = /^Deliver every\s+(?:(\d+)\s+)?(day|week|month|year)s?/i;
  var PLAN_ADJ = { day: 'יומי', week: 'שבועי', month: 'חודשי', year: 'שנתי' };
  var PLAN_PLURAL = { day: 'ימים', week: 'שבועות', month: 'חודשים', year: 'שנים' };

  function planLabels() {
    document.querySelectorAll('.cart-items__variants-wrapper p').forEach(function (el) {
      var txt = (el.textContent || '').trim();
      var m = txt.match(PLAN_EN);
      if (!m) return;
      var unit = m[2].toLowerCase();
      var n = m[1] ? parseInt(m[1], 10) : 1;
      var head = n > 1
        ? 'מנוי, נשלח כל ' + n + ' ' + (PLAN_PLURAL[unit] || 'חודשים')
        : 'מנוי ' + (PLAN_ADJ[unit] || 'חודשי');
      var off = txt.match(/(\d+(?:\.\d+)?)\s*%/);
      el.textContent = off ? head + ', ' + off[1] + ' אחוז הנחה' : head;
    });
  }

  /* ---------- כפתורי הארנק יוצאים מהסרגל הנעוץ ----------
   * ⛔ בטלפון שופיפיי עורם את Shop Pay, PayPal ו-Google Pay אחד מתחת
   * לשני. מדדתי במסך 812: שלושת הכפתורים 176 פיקסל, טקסט ההסכמה עוד 107,
   * והסרגל הנעוץ תפח ל-542, כלומר שני שליש מהמגירה, ולא נשאר מקום לראות
   * מה בכלל בעגלה.
   * ⛔ ניסיתי קודם לסדר אותם בשורה אחת דרך CSS, גם בגריד וגם בפלקס.
   * האלמנט של שופיפיי מחזיר אותם לטור בכל מקרה, וזה גם קוד שלהם שישתנה
   * מתי שהם ירצו, אז אין טעם להיאבק בו.
   * ⭐ במקום זה הם פשוט יוצאים מהסרגל ונכנסים לסוף אזור הגלילה, ממש
   * מעל הסיכום. הם עדיין צמודים לכפתור התשלום למי שגולל עד הסוף, אבל
   * כבר לא תופסים מקום קבוע על המסך.
   * ⛔ רק במגירה. בעמוד העגלה אין סרגל נעוץ ואין מה לפנות.
   */
  
  var DROP_WALLETS = true;

  function liftWallets() {
    if (DROP_WALLETS) {
      document.querySelectorAll(
        '.cart-drawer__summary .additional-checkout-buttons,' +
        ' .cart-summary .additional-checkout-buttons'
      ).forEach(function (wallets) { wallets.remove(); });
      return;
    }
    document.querySelectorAll('.cart-drawer__summary').forEach(function (summary) {
      var wallets = summary.querySelector('.additional-checkout-buttons');
      if (!wallets || !summary.parentNode) return;
      wallets.setAttribute('data-ka-wallets', '');
      summary.parentNode.insertBefore(wallets, summary);
    });
  }


  /* ⛔ הגנת המשלוח לא נשארת באזור הגולל. היא נכנסת אל תוך סרגל הסיכום,
     מעל הסכום וכפתור התשלום, כדי שהיא תשב במקום קבוע ולא תזוז בגלילה. */
  function placePinned() {
    document.querySelectorAll('.ka-cxp').forEach(function (row) {
      var scope = row.closest('cart-items-component')
        || row.closest('[id^="shopify-section-"]') || document;
      var summary = scope.querySelector('.cart-drawer__summary, .cart-summary');
      if (!summary) { row.classList.add('is-placed'); return; }
      var host = summary.querySelector('.cart-summary__inner') || summary;
      if (host.firstElementChild !== row) host.insertBefore(row, host.firstChild);
      row.classList.add('is-placed');
    });
  }

  function place() {
    liftWallets();
    document.querySelectorAll('.ka-cx').forEach(function (cx) {
      // ⛔ document.querySelector picked the FIRST summary on the page. On the
      // cart page the drawer markup sits in the header, above main, so the cart
      // page block was being lifted into the drawer. Scoped to its own section.
      var scope = cx.closest('cart-items-component')
        || cx.closest('[id^="shopify-section-"]') || document;
      var summary = scope.querySelector('.cart-drawer__summary, .cart-summary');

      // ⛔⛔⛔ להיות אח של הסיכום זה לא מספיק. בעמוד העגלה ההורה הוא
      // `display: grid` עם `grid-template-rows: subgrid`, והסיכום תופס
      // `grid-row: 1 / -1`, כלומר את **כל** השורות. כל אח נוסף נוחת באותם
      // תאים והשניים נערמים זה על זה. זה מה שנראה כמו עגלה שבורה.
      // ⭐ הפתרון: להיכנס **פנימה**, לתוך `.cart-summary__inner`, שם הזרימה
      // רגילה ואין גריד. נופלים חזרה להצבה כאח רק אם אין פנים.
      var inner = summary ? summary.querySelector('.cart-summary__inner') : null;
      if (inner) {
        // ⛔⛔⛔ 20.10.2026: עם הגנת המשלוח, placePinned שם את .ka-cxp ראשון באותו
        // inner, והשורה הזאת החזירה את .ka-cx לראש. כל הזזה הפעילה את
        // ה-MutationObserver שהריץ את שתיהן שוב, וזו לולאה בלי סוף שהקפיאה את
        // /cart עוד לפני שסיים להיטען. ⭐ ההגנה שומרת על הראש, והבלוק יושב מיד מתחתיה.
        var pin = inner.firstElementChild && inner.firstElementChild.classList.contains('ka-cxp')
          ? inner.firstElementChild : null;
        var ref = pin ? pin.nextElementSibling : inner.firstElementChild;
        if (ref !== cx) {
          inner.insertBefore(cx, ref);
        }
        cx.classList.add('is-placed');
      } else if (summary && summary.parentNode) {
        /* ⛔ הכפתורים של הארנקים כבר הוזזו לכאן, וההגנה והמתנות צריכות
           לשבת מעליהם ולא מתחתיהם. בלי העוגן הזה כל סיבוב של המשקיף
           דחף את הבלוק שוב מתחת לכפתורים. */
        var anchor = summary.parentNode.querySelector('[data-ka-wallets]') || summary;
        if (anchor.previousElementSibling !== cx) {
          summary.parentNode.insertBefore(cx, anchor);
        }
        cx.classList.add('is-placed');
      } else {
        // ⛔ is-placed used to be set even when the move failed, so the block
        // appeared under the checkout button and only jumped up on the next
        // mutation. Revealed here only because a summary genuinely is not
        // there, and invisible for ever would be the worse of the two.
        cx.classList.add('is-placed', 'is-unplaced');
      }
    });
    placePinned();
    planLabels();
  }
  window.__kaCxPlace = place;

  /* ---------------------------------------------------- מקום הגלילה
   * ⛔ Horizon נועל את הגלילה עם body{position:fixed;top:0} ולא שומר את
   * ההיסט. נמדד: נפתח ב-627, נסגר ב-0, וגובה המסמך צנח ל-932 בזמן
   * שהמגירה פתוחה. הקונה רואה דף שקפץ לראש ונראה כאילו נעלם לו תוכן.
   */
  (function keepScroll() {
    var lastY = 0, savedY = 0, locked = false;

    window.addEventListener('scroll', function () {
      if (!locked) lastY = window.scrollY || document.documentElement.scrollTop || 0;
    }, { passive: true });

    function onOpen() {
      if (locked) return;
      locked = true;
      /* ⛔ לא קוראים כאן scrollY: ייתכן שהנעילה כבר אפסה אותו. lastY
         נרשם באירוע הגלילה האחרון שקרה לפני הנעילה. */
      savedY = lastY;
    }

    function onClose() {
      if (!locked) return;
      locked = false;
      var y = savedY;
      /* מסגרת אחת לשחרור position:fixed, ואז מחזירים את המקום */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (y > 0 && (window.scrollY || 0) < 2) window.scrollTo(0, y);
          lastY = y;
          /* נגיעה בפריסה כדי לאלץ ציור מחדש אחרי שהמסמך היה בגובה אפס */
          var h = document.documentElement;
          h.style.minBlockSize = '100.001%';
          requestAnimationFrame(function () { h.style.minBlockSize = ''; });
        });
      });
    }

    function isCartDialog(el) {
      return el && el.tagName === 'DIALOG' && el.closest
        && el.closest('cart-drawer-component');
    }

    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (!isCartDialog(t)) continue;
        if (t.hasAttribute('open')) onOpen();
        else onClose();
      }
    }).observe(document.documentElement, {
      attributes: true, subtree: true, attributeFilter: ['open'],
    });
  })();

  function sectionIdOf(el) {
    var sec = el.closest('[id^="shopify-section-"]');
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }

  function paint(sectionId, html) {
    var host = document.getElementById('shopify-section-' + sectionId);
    if (!host || !html) return false;

    var next = document.createElement('div');
    next.innerHTML = html;

    // first match only: the selectors are nested, so swapping twice would undo it
    for (var i = 0; i < PANELS.length; i++) {
      var from = next.querySelector(PANELS[i]);
      var to = host.querySelector(PANELS[i]);
      if (from && to) {
        to.replaceWith(from);
        return true;
      }
    }

    /* ⛔⛔⛔ כאן היה host.innerHTML = html, וזה מה שקבר את הכותרת העליונה.
       שופיפיי מחזיר סקשן **כולל העטיפה שלו**, כלומר
       <header id="shopify-section-...">, ודחיפה שלה אל תוך העטיפה הקיימת
       יצרה שתי עטיפות מקוננות עם אותו id בדיוק. מדדתי את זה: ה-id הופיע
       פעמיים באותו עמוד והכותרת קפצה מ-66 ל-82 פיקסל. מכיוון שהמגירה
       יושבת בתוך סקשן הכותרת, כל רענון של המגירה עבר דרך השורה הזאת,
       וזה מה שהשאיר פס ריק במקום הלוגו והתפריט.
       ⭐ מחליפים את העטיפה עצמה ולא את מה שבתוכה, בדיוק כמו ששופיפיי
       עושה בעצמו, וכך נשארת עטיפה אחת בלבד. */
    /* ⛔⛔⛔ סקשן הכותרת לא נוגעים בו לעולם. המגירה יושבת בתוכו, אז כל
       רענון של המגירה הגיע לכאן וצייר מחדש גם את הלוגו ואת התפריט.
       מדדתי את התוצאה פעמיים: הכותרת קפצה מ-66 ל-82 פיקסל, כי הרינדור
       הטרי חוזר במצב ההתחלתי שלו והסקריפט שמכווץ אותה כבר לא רץ שוב.
       עדיף רענון עמוד מכוער ונדיר מאשר כותרת שנראית שבורה. */
    if (host.querySelector('cart-drawer-component')) return false;

    if (!host.querySelector('dialog[open]')) {
      var fresh = next.querySelector('[id="shopify-section-' + sectionId + '"]')
        || next.firstElementChild;
      if (fresh) host.replaceWith(fresh);
      else host.innerHTML = html;
      return true;
    }
    return false;
  }

  function post(url, body, sectionId) {
    body.sections = sectionId;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-ka-cx-toggle]');
    if (!btn || busy) return;
    var row = btn.closest('[data-ka-cx-vip]');
    if (!row) return;

    ev.preventDefault();
    markSeen();          // the shopper decided; never auto add again
    busy = true;
    row.classList.add('is-busy');

    var on = row.classList.contains('is-on');
    var sectionId = sectionIdOf(row);
    var done;

    if (on) {
      // remove by line key, which survives quantity edits on other lines
      done = post('/cart/change.js', { id: row.getAttribute('data-key'), quantity: 0 }, sectionId);
    } else {
      done = post('/cart/add.js', {
        items: [{ id: Number(row.getAttribute('data-variant')), quantity: 1 }],
      }, sectionId);
    }

    done.then(function (data) {
      var html = data && data.sections && sectionId ? data.sections[sectionId] : null;
      if (!paint(sectionId, html)) {
        // rather than leave the shopper looking at a stale total
        window.location.reload();
        return;
      }
      place();
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: data }));
    }).catch(function () {
      window.location.reload();
    }).finally(function () {
      busy = false;
      row.classList.remove('is-busy');
    });
  });

  /* ---------------------------------------------------------------- אפסל
   * אותו מנגנון של כפתור ההגנה: מוסיפים לעגלה ומציירים מחדש את הסקשן.
   * ⛔ בלי הציור מחדש המגירה נשארת עם המצב הישן, והקונה לוחץ ולא רואה
   * שהמוצר נכנס, ואז לוחץ שוב.
   */
  document.addEventListener('click', function (ev) {
    var add = ev.target.closest('[data-ka-up-add]');
    if (!add || busy) return;
    ev.preventDefault();
    busy = true;
    add.classList.add('is-busy');
    var sectionId = sectionIdOf(add);
    post('/cart/add.js', {
      items: [{ id: Number(add.getAttribute('data-variant')), quantity: 1 }],
    }, sectionId).then(function (data) {
      var html = data && data.sections && sectionId ? data.sections[sectionId] : null;
      if (!paint(sectionId, html)) {
        window.location.reload();
        return;
      }
      place();
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: data }));
    }).catch(function () {
      window.location.reload();
    }).finally(function () {
      busy = false;
      add.classList.remove('is-busy');
    });
  });

  /* The protection starts switched on, as asked.
   *
   * ⚠️ It must never switch itself back on after the shopper turns it off, or
   * the toggle stops being a real choice. A session flag is set both when we
   * auto add it and when the shopper touches the toggle, so the auto add can
   * only ever happen once, on the first cart of the session.
   */
  var AUTO = 'kaCxAuto';

  function seen() {
    try { return sessionStorage.getItem(AUTO) === '1'; } catch (e) { return true; }
  }
  function markSeen() {
    try { sessionStorage.setItem(AUTO, '1'); } catch (e) {}
  }

  function autoEnable() {
    if (busy || seen()) return;
    var row = document.querySelector('[data-ka-cx-vip][data-ka-cx-default-on]');
    if (!row) return;
    markSeen();
    var sectionId = sectionIdOf(row);
    busy = true;
    post('/cart/add.js', {
      items: [{ id: Number(row.getAttribute('data-variant')), quantity: 1 }],
    }, sectionId).then(function (data) {
      var html = data && data.sections && sectionId ? data.sections[sectionId] : null;
      if (paint(sectionId, html)) place();
    }).catch(function () {}).finally(function () { busy = false; });
  }

  // ⭐ ההצבה רצה מיד. הסקריפט נטען מיד אחרי הבלוק עצמו, כך ששני האלמנטים כבר
  // קיימים, וההזזה קורית לפני הציור הראשון ולא אחריו.
  place();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { place(); autoEnable(); });
  } else {
    autoEnable();
  }
  // Horizon re renders the cart on its own too, so keep watching for new nodes
  new MutationObserver(function () { place(); autoEnable(); })
    .observe(document.body, { childList: true, subtree: true });
})();
